import { z } from 'zod';

/** ISO-8601 时间戳字符串 */
export const TimestampSchema = z.string().datetime();
export type Timestamp = z.infer<typeof TimestampSchema>;

/** 资源 ID（带前缀的字符串，如 bt-7782 / as-12 / cfg-1） */
export const IdSchema = z.string().min(1).max(64);
export type Id = z.infer<typeof IdSchema>;

/** 分页游标 */
export const CursorSchema = z.string().optional();
export type Cursor = z.infer<typeof CursorSchema>;

export const PaginationSchema = z.object({
  cursor: CursorSchema,
  // limit 走 coerce：GET query 里是字符串，POST body 里是数字，两种来源都吃
  limit: z.coerce.number().int().min(1).max(200).default(20),
});
export type Pagination = z.infer<typeof PaginationSchema>;

export const PageSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    items: z.array(item),
    nextCursor: z.string().nullable(),
  });

/** 通用 OK 响应 */
export const OkSchema = z.object({ ok: z.literal(true) });
export type Ok = z.infer<typeof OkSchema>;
